<div class="fs-2 with-close" mat-dialog-title>
    Aperçu de l'annonce
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <div class="row">
        <div class="col-md-7 col-12">
            <img *ngIf="favorite.pictures.length == 0" src="assets/no-photo.png" alt=""/>
            <div *ngIf="favorite.pictures.length > 0" id="picturesCarouselPreview{{favorite.ad.ai_id}}"
                 class="carousel slide" data-ride="carousel">
                <div class="carousel-inner">
                    <div *ngFor="let picture of favorite.pictures; index as ig;"
                         [ngClass]="{'carousel-item': true, 'active': ig == 0}"
                         style="background-image: url('{{ picture }}')">
                        <img *ngIf="picture" style="display: none;" src="{{ picture }}"
                             (error)="changeImg($event, ig, favorite.ad.ai_id)">
                    </div>
                </div>
                <button *ngIf="favorite.pictures.length > 1" class="carousel-control-prev"
                        type="button"
                        [attr.data-bs-target]="'#picturesCarouselPreview' + favorite.ad.ai_id"
                        data-bs-slide="prev">
                    <i class="fa fa-chevron-left"
                       (click)="trackingService.click('search_result_image_prev', favorite.ad.ai_id);"></i>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button *ngIf="favorite.pictures.length > 1" class="carousel-control-next"
                        type="button"
                        [attr.data-bs-target]="'#picturesCarouselPreview' + favorite.ad.ai_id"
                        data-bs-slide="next">
                    <i class="fa fa-chevron-right"
                       (click)="trackingService.click('search_result_image_next', favorite.ad.ai_id);"></i>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
        </div>
        <div class="col-md-5 col-12">
            <h3>{{ favorite.title }}</h3>
            <p class="descriptif" [innerHTML]="favorite.ad.description | nl2br"></p>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()" class="btn btn-outline">
        Fermer
    </button>
    <button type="button" (click)="onYesClick()" class="btn btn-primary">
        Ouvrir l'analyse
    </button>
</div>
